import React from 'react';

import {
    Step,
    Stepper,
    StepLabel,
    StepContent
  } from 'material-ui/Stepper';

  import RaisedButton from 'material-ui/RaisedButton';
  import FlatButton from 'material-ui/FlatButton';
  
  /**
   * Horizontal steppers are ideal when the contents of one step depend on an earlier step.
   * Avoid using long step names in horizontal steppers.
   *
   * Linear steppers require users to complete one step in order to move on to the next.
   */

  // const Null = props => (
  //   <div></div>
  // );

  class AuthStepper extends React.Component {
  
    state = {
      child: [],
      finished: false,
      stepIndex: 0,
    };
    
    componentDidMount() {
        this.updateWindowDimensions();
        window.addEventListener('resize', this.updateWindowDimensions);
        this.mapChildrenToState();
    }
    
    componentWillUnmount() {
        window.removeEventListener('resize', this.updateWindowDimensions);
    }
    
    updateWindowDimensions = () => {
        this.setState({ width: window.innerWidth, height: window.innerHeight });
    }

    mapChildrenToState = () => {
      let filteredChildrenArray = this.props.children.filter(child => child.props.label);

      React.Children.map(filteredChildrenArray, (child, i) => {
            
            this.setState(prevState => ({
                child: [
                  ...prevState.child,
                  {
                    content: child,
                    label: child.props['label'],
                    nextAction: child.props['nextAction'],
                    nextLabel: child.props['nextLabel'],
                  }
                ]
            }), () => {
              this.props.setFinalStep(this.state.child.length - 1);
            });
        });
    }
    componentWillReceiveProps(nextProps) {
      // (nextProps.isAuthenticated && this.props.step === 0) ? this.props.advanceStepper() : null;
      
      // if(nextProps.showSignUp !== this.props.showSignUp) {
      //   this.setState({
      //     showSignUp: nextProps.showSignUp
      //   }, ()=>{
      //     // this.handleNext();
      //   })
      // }
      // if(nextProps.errors !== this.props.errors) {
      //   this.setState({
      //     errors: nextProps.errors
      //   }, ()=>{
      //     // this.handleNext();
      //   })
      // }
    }

    handleNext = () => {
      const {stepIndex} = this.state;
      this.setState({
        finished: stepIndex >= this.state.child.length - 1,
        stepIndex: stepIndex + 1,
      });
    };
  
    handlePrev = () => {
      const {stepIndex} = this.state;
      if (stepIndex > 0) {
        this.setState({stepIndex: stepIndex - 1});
      }
    };
  
    getStepContent = (stepIndex) => {
        return (this.state.child[stepIndex]) ? this.state.child[stepIndex].content : null;
    }
    
    getStepLabel = (stepIndex) => {
        return  (this.state.child[stepIndex]) ? this.state.child[stepIndex].label : null;
    }
  
    renderStepActions(step) {
        const {stepIndex} = this.state;
        // console.log((this.state.child[stepIndex]) ? this.state.child[stepIndex].nextLabel : 'Next')
        return (
          <div style={{margin: '12px 0'}}>
            
            {/* {this.props.step > 0 && ( */}
              <div>
                <RaisedButton
                  label={this.props.step === (this.state.child.length - 1) ? 'Finish' : (this.state.child[this.props.step]) ? this.state.child[this.props.step].nextLabel : 'Next' } /* add custom label here */
                  disableTouchRipple={true}
                  disableFocusRipple={true}
                  primary={true}
                  onClick={this.props.advanceStepper} 
                  style={{marginRight: 12}}
                />
                <FlatButton
                  label="Back"
                  disabled={this.props.step === 0}
                  disableTouchRipple={true}
                  disableFocusRipple={true}
                  onClick={this.props.reverseStepper}/*this.handlePrev*/
                />
                <FlatButton
                  label="Cancel"
                  disableTouchRipple={true}
                  disableFocusRipple={true}
                  onClick={this.props.handleClose} /* TODO: Also erase error data */
                /> 
              </div>
          {/* )} */}
          </div>
        );
      }

      mobileCheck = () => {
          return (this.state.width < 760 ) ? true : false;
      }

      filterNull = (childArray, itemToRemove) =>  {
        let filteredChildArray = new Array();
        for (let i = 0; i < childArray.length; i++) {
          if (typeof childArray[i] !== 'function Null()') {
            filteredChildArray.push(childArray[i]);
          }
        }
        return filteredChildArray;
      }

    render() {
      const {finished, stepIndex} = this.state;
      const contentStyle = {margin: '0 16px'};
      const children = this.filterNull(this.props.children, '');
      // console.log('%cCHILDREN','color: gold');
      // console.log(children);
      const childrenArray = React.Children.toArray(this.props.children);
      let filteredChildrenArray = childrenArray.filter(child => child.props.label);
      

      return (
        <div style={{width: '100%', maxWidth: 900, margin: 'auto', marginTop: -10, marginBottom: 70, ...this.props.style}}>
          <Stepper activeStep={this.props.step} orientation={(this.mobileCheck() ? 'vertical' : 'horizontal')}>
            {React.Children.map(filteredChildrenArray, (child, i) => {
              return (<Step key={i}>
                <StepLabel>{this.getStepLabel(i, filteredChildrenArray)}</StepLabel>
                {this.mobileCheck() 
                  ? <StepContent>
                          {this.getStepContent(this.props.step)}
                          {/* {this.renderStepActions(this.props.step)} */}
                      </StepContent>
                  : <div></div>
                }
              </Step>);
            })}
          </Stepper>

          { !this.mobileCheck() && <div style={contentStyle}>
            {finished ? (
              <p>
                <a
                  href="#"
                  onClick={(event) => {
                    event.preventDefault();
                    this.setState({stepIndex: 0, finished: false});
                  }}
                >
                  Click here
                </a> to reset the example.
              </p>
            ) : (
              <div>
                {this.getStepContent(this.props.step)}
                {/* {this.renderStepActions(this.props.step)} */}
              </div>
            )}
          </div>
          }
        </div>
      );
    }
  }
  
  export default AuthStepper;


// WEBPACK FOOTER //
// ./src/js/components/Stepper/AuthStepper.jsx